import { ClbIcon } from '@celebration/react/ClbIcon/ClbIcon';
import { useTranslation } from 'react-i18next';
import './copy-info.scss';

interface CopyInfoProps {
    title: string;
    info: string;
}

function CopyInfo({ title, info }: Readonly<CopyInfoProps>) {
    const { t } = useTranslation();

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text);
    };

    return (
        <span className="copy-info-span" data-testid="copy-info-span">
            {`${t(title)} ${info}`}
            <ClbIcon
                icon="copy"
                onClick={() => copyToClipboard(info)}
                data-testid={`copy-${title}-icon`}
            />
        </span>
    );
}

export default CopyInfo;
